import * as React from 'react';
import { PieChart } from '@mui/x-charts/PieChart';

export default function PieDiagram(props:any) {

    const {mappedPercent} = props

    // let mappedPercent: number = Math.round((mapped/(mapped + unmapped))*100)
    // let unmappedPercent: number = Math.round((unmapped/(mapped + unmapped))*100)

    return (
        <PieChart
            series={[
                {
                    arcLabel: (item) => `${item.value}%`,
                    arcLabelMinAngle: 20,

                    data: [
                        { id: 0, value: mappedPercent, label: "mapped", color: "#ccffcc" },
                        { id: 1, value: Math.round((100-mappedPercent)*10)/10, label: "not mapped", color: "#cccccc" },    // #ffcccc - light-light-red
                        // { id: 2, value: 20, label: 'series C' },
                    ],
                },
            ]}
            margin={{ top: 0, bottom: 0, left: 0, right:0 }}
            slotProps={{
                legend: {
                    hidden: true,    // set "false" to ENABLE
                    direction: 'row',
                    position: {vertical: 'bottom', horizontal: 'left'},
                    padding: 0,
                    itemMarkWidth: 10,
                    itemMarkHeight: 3,
                    labelStyle: {
                        fontSize: 10,
                        fill: 'grey',
                    },

                }
            }}
            width={250}
            height={150}
        />
    );
}
